import { allSport5000 } from "./all-sport-5000";
import clock from "./clock";
import display from "./display";
import { guidance } from "./guidance";
import scoreboard from "./scoreboard";
import { setVolume } from "./sound";
import { clearButtons, shrinkWrap } from "./svg-buttons";

setVolume(0.5);
document.getElementById("volume-slider")!.addEventListener("input", (e) => {
    setVolume(+(e.target as HTMLInputElement).value);
});

guidance.clearRegistry();
clearButtons();
allSport5000();
shrinkWrap();

display.line1(" ");
display.line2(" ");
scoreboard.reset();
clock.setMainClockVal(0);


// scoreboard.addGuestPenalty({
//     time: 120000,
//     playerNumber: 8
// });
// scoreboard.addGuestPenalty({
//     time: 120000,
//     playerNumber: 62
// });
